// Helpers for parsing YouTube URLs and building embed URLs / thumbnails.
// Supports watch, youtu.be, /embed, /shorts, /v links, and raw 11-char IDs.

export const parseYouTubeId = (input) => {
  if (!input || typeof input !== 'string') return null;
  const raw = input.trim();
  if (/^[A-Za-z0-9_-]{11}$/.test(raw)) return raw;

  const re = /(?:youtube\.com\/(?:watch\?(?:[^#]*&)?v=|embed\/|shorts\/|v\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/;
  const m = raw.match(re);
  return m ? m[1] : null;
};

export const getYouTubeEmbedUrl = (videoId, opts = {}) => {
  if (!videoId) return null;
  const params = new URLSearchParams();
  params.set('rel', '0');
  params.set('modestbranding', '1');
  params.set('playsinline', '1');
  params.set('iv_load_policy', '3');
  if (opts.enablejsapi) params.set('enablejsapi', '1');
  if (opts.controls === false) params.set('controls', '0');
  if (opts.disablekb) params.set('disablekb', '1');
  if (opts.autoplay) params.set('autoplay', '1');
  if (opts.mute) params.set('mute', '1');
  if (opts.loop) {
    params.set('loop', '1');
    params.set('playlist', videoId);
  }
  if (opts.start != null) params.set('start', String(opts.start));
  if (opts.origin) params.set('origin', opts.origin);
  return `https://www.youtube-nocookie.com/embed/${videoId}?${params.toString()}`;
};

export const getYouTubeThumbnail = (videoId) => {
  if (!videoId) return null;
  return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
};
